/* The Archive's door (snippets/mm-archive-door.liquid, in sections/mm-archive-entry.liquid). The
   section counts the first 250 pairs it is given; this asks for the later pages of the same section and adds their
   available pairs to the count and the size stick's tiles. */
class MmArchiveEntry extends HTMLElement {
  async connectedCallback() {
    const pages = Number(this.dataset.pages || 1);
    if (pages < 2) return;
    let tally = this.dataset.tally || '';
    try {
      for (let page = 2; page <= pages; page += 1) {
        const url = new URL(window.location.pathname, window.location.origin);
        url.searchParams.set('section_id', this.dataset.section);
        url.searchParams.set('page', page);
        const res = await fetch(url);
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const more = doc.querySelector('mm-archive-entry');
        if (more) tally += more.dataset.tally || '';
      }
    } catch (e) {
      return; // the first page's count stays
    }
    this.render(tally);
  }

  // one string per count: Shopify's own one / other forms, the number put in where the 99999 stood
  say(kind, n) {
    return (n === 1 ? this.dataset[`${kind}One`] : this.dataset[`${kind}Other`]).replace('99999', n);
  }

  render(tally) {
    const counts = new Map();
    tally.split('|').filter(Boolean).forEach((eu) => counts.set(eu, (counts.get(eu) || 0) + 1));
    const total = Array.from(counts.values()).reduce((a, b) => a + b, 0);
    const section = this.querySelector('.mm-archive-entry');
    if (!section || !total) return;
    const count = this.querySelector('[data-mm-count]');
    if (count) count.innerHTML = this.say('count', total);
    const list = this.querySelector('[data-mm-size-tiles]');
    if (list) {
      const most = Math.max(...counts.values());
      const cms = new Map((list.dataset.cm || '').split('|').filter(Boolean).map((p) => p.split(':')));
      const model = list.querySelector('li');
      Array.from(counts.keys()).sort((a, b) => Number(a) - Number(b)).forEach((eu) => {
        let item = Array.from(list.children).find((li) => li.querySelector(`[data-mm-size-tile="${CSS.escape(eu)}"]`));
        if (!item && model) {
          item = model.cloneNode(true);
          const a = item.querySelector('a');
          a.href = `${list.dataset.url}?size=${encodeURIComponent(eu)}#MmArchiveGrid`;
          a.dataset.mmSizeTile = eu;
          item.querySelector('.mm-size-tile__eu').textContent = eu;
        }
        if (!item) return;
        const n = counts.get(eu);
        const low = n <= 2;
        const a = item.querySelector('a');
        const said = (low ? list.dataset.last : list.dataset.pairs).replace('99999', n);
        const cm = cms.get(eu);
        const tip = cm ? `${list.dataset.cmLabel.replace('__CM__', cm)} · ${said}` : said;
        const tile = item.querySelector('.mm-size-tile__n');
        tile.classList.toggle('is-low', low);
        tile.textContent = (low ? list.dataset.tileLast : list.dataset.tilePairs).replace('99999', n);
        item.querySelector('.mm-size-tile__bar i').style.setProperty('--n', (n / most).toFixed(3));
        item.querySelector('.mm-size-tile__tip').textContent = tip;
        a.setAttribute('aria-label', `EU ${eu}, ${tip.replace(' · ', ', ')}`);
        list.appendChild(item);
      });
    }
    section.hidden = false;
  }
}

if (!customElements.get('mm-archive-entry')) customElements.define('mm-archive-entry', MmArchiveEntry);
